// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login_button_loginButton__yCiZv {
  padding: 0.6rem 1.5rem;
  border-radius: 5rem;
  font-size: 1rem;
  color: var(--text-color0);
  font-weight: bold;
}

.login_button_loginButton__yCiZv:hover {
  color: var(--text-color2);
}

.login_button_loginButton__yCiZv:active {
  transform: translateY(0.1rem);
  transition: transform 0.01s ease;
}

.login_button_loginButton__yCiZv svg {
  font-size: 1.2rem;
  opacity: 1;
}

.login_button_loginButton__yCiZv:hover svg {
  font-size: 1.2rem;
  opacity: 1;
  color: var(--text-color0);
}

.login_button_loginButton__yCiZv .login_button_cardFlipEffect__D5EKV {
  width: 100%;
  height: 100%;
  position: absolute;
  transform-style: preserve-3d;
  top: 0;
  left: 0;
  border-radius: 1.4rem;
  opacity: 0.3;
  z-index: 1;
}

.login_button_loginButton__yCiZv:hover .login_button_cardFlipEffect__D5EKV {
  transform: rotateY(180deg);
  background-color: var(--accent-color1);
}

@media (max-width: 600px) {
  .login_button_loginButton__yCiZv {
    padding: 0.4rem 1rem;
    font-size: 0.85rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SpecificStyles/login_button.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,MAAM;EACN,OAAO;EACP,qBAAqB;EACrB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;AACxC;;AAEA;EACE;IACE,oBAAoB;IACpB,kBAAkB;EACpB;AACF","sourcesContent":[".loginButton {\n  padding: 0.6rem 1.5rem;\n  border-radius: 5rem;\n  font-size: 1rem;\n  color: var(--text-color0);\n  font-weight: bold;\n}\n\n.loginButton:hover {\n  color: var(--text-color2);\n}\n\n.loginButton:active {\n  transform: translateY(0.1rem);\n  transition: transform 0.01s ease;\n}\n\n.loginButton svg {\n  font-size: 1.2rem;\n  opacity: 1;\n}\n\n.loginButton:hover svg {\n  font-size: 1.2rem;\n  opacity: 1;\n  color: var(--text-color0);\n}\n\n.loginButton .cardFlipEffect {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  transform-style: preserve-3d;\n  top: 0;\n  left: 0;\n  border-radius: 1.4rem;\n  opacity: 0.3;\n  z-index: 1;\n}\n\n.loginButton:hover .cardFlipEffect {\n  transform: rotateY(180deg);\n  background-color: var(--accent-color1);\n}\n\n@media (max-width: 600px) {\n  .loginButton {\n    padding: 0.4rem 1rem;\n    font-size: 0.85rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginButton": `login_button_loginButton__yCiZv`,
	"cardFlipEffect": `login_button_cardFlipEffect__D5EKV`
};
export default ___CSS_LOADER_EXPORT___;
